if ( typeof StickyBar !== 'function' ) {

	class StickyBar extends HTMLElement {

		constructor() {
			super();
			this.init();
		}

		init() {
			this.stickyBar = document.getElementById('product-sticky-bar');
			this.productVariants = document.querySelector('product-variants');
			this.mainProductForm = document.querySelector('[id^="add-to-cart-"]');
			this.stickyProductForm = document.querySelector('#sticky-product-form');
			
			if (!this.stickyBar || !this.productVariants) return;

			this.setupStickyBar();
			this.setupScrollListener();
			this.setupVariantSync();
			this.setupFormSync();
		}

	setupStickyBar() {
		// Show the sticky bar initially (but keep it hidden with transform)
		this.stickyBar.style.display = 'block';
		// Ensure it starts hidden by explicitly removing is-visible class
		this.stickyBar.classList.remove('is-visible');
		
		// Add event listener for variant changes
		this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChange.bind(this));
		
		// Handle add to cart events from sticky form
		const stickyForm = this.stickyBar.querySelector('product-form');
		if (stickyForm) {
			stickyForm.addEventListener('add-to-cart', () => {
				// Show cart drawer if using overlay cart
				if (KROWN.settings.cart_action === 'overlay') {
					document.getElementById('site-cart-sidebar').show();
					if (document.getElementById('cart-recommendations')) {
						document.getElementById('cart-recommendations').generateRecommendations();
					}
				}
			});
		}
	}

	setupScrollListener() {
		let lastScrollTop = 0;
		const scrollThreshold = 300; // Show sticky bar after scrolling 300px
		let isVisible = false;

		const handleScroll = () => {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			const productActions = document.querySelector('.product-actions');
			
			if (!productActions) return;

			const productActionsRect = productActions.getBoundingClientRect();
			const productActionsBottom = productActionsRect.bottom;
			const windowHeight = window.innerHeight;

			// Show sticky bar when product actions are out of view AND after scroll threshold
			// Use AND condition to prevent showing immediately on load
			if (scrollTop > scrollThreshold && productActionsBottom < 0) {
				if (!isVisible) {
					this.stickyBar.classList.add('is-visible');
					isVisible = true;
				}
			} else {
				if (isVisible) {
					this.stickyBar.classList.remove('is-visible');
					isVisible = false;
				}
			}

			lastScrollTop = scrollTop;
		};

	// Explicitly ensure sticky bar is hidden on page load
	this.stickyBar.classList.remove('is-visible');
	
	// Add scroll listener
	window.addEventListener('scroll', handleScroll, { passive: true });
	
	// Add resize listener to recalculate on window resize
	window.addEventListener('resize', handleScroll, { passive: true });
	}

		setupVariantSync() {
			// Sync variant selection between main form and sticky form
			if (this.productVariants) {
				this.productVariants.addEventListener('VARIANT_CHANGE', () => {
					this.updateStickyBar();
				});
			}
		}

		setupFormSync() {
			// Sync form data between main form and sticky form
			if (this.mainProductForm && this.stickyProductForm) {
				const mainForm = this.mainProductForm.querySelector('form');
				const stickyForm = this.stickyProductForm;

				// Sync variant ID
				const mainVariantInput = mainForm.querySelector('input[name="id"]');
				const stickyVariantInput = stickyForm.querySelector('input[name="id"]');

				if (mainVariantInput && stickyVariantInput) {
					stickyVariantInput.value = mainVariantInput.value;
				}

				// Sync quantity
				const mainQuantityInput = mainForm.querySelector('.product-quantity__selector');
				const stickyQuantityInput = stickyForm.querySelector('.product-quantity__selector');

				if (mainQuantityInput && stickyQuantityInput) {
					// Sync quantity changes
					mainQuantityInput.addEventListener('change', () => {
						stickyQuantityInput.value = mainQuantityInput.value;
					});

					stickyQuantityInput.addEventListener('change', () => {
						mainQuantityInput.value = stickyQuantityInput.value;
					});

					// Sync quantity button clicks
					const mainQuantityButtons = mainForm.querySelectorAll('.qty-minus, .qty-plus');
					const stickyQuantityButtons = stickyForm.querySelectorAll('.qty-minus, .qty-plus');

					mainQuantityButtons.forEach((button, index) => {
						button.addEventListener('click', () => {
							setTimeout(() => {
								stickyQuantityInput.value = mainQuantityInput.value;
							}, 100);
						});
					});

					stickyQuantityButtons.forEach((button, index) => {
						button.addEventListener('click', () => {
							setTimeout(() => {
								mainQuantityInput.value = stickyQuantityInput.value;
							}, 100);
						});
					});
				}
			}
		}

		onVariantChange(event) {
			this.updateStickyBar();
		}

		updateStickyBar() {
			if (!this.productVariants.currentVariant) return;

			const variant = this.productVariants.currentVariant;
			
			// Update price
			const stickyPrice = this.stickyBar.querySelector('[data-js-sticky-price]');
			if (stickyPrice) {
				stickyPrice.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
			}

			// Update variant ID in sticky form
			const stickyVariantInput = this.stickyBar.querySelector('input[name="id"]');
			if (stickyVariantInput) {
				stickyVariantInput.value = variant.id;
			}

			// Update add to cart button state
			const stickyAddToCartButton = this.stickyBar.querySelector('[data-js-product-add-to-cart]');
			const stickyAddToCartText = this.stickyBar.querySelector('[data-js-product-add-to-cart-text]');
			const stickyQuantitySelector = this.stickyBar.querySelector('[data-js-product-quantity]');

			if (stickyAddToCartButton && stickyAddToCartText) {
				if (!variant.available) {
					stickyAddToCartButton.classList.add('disabled');
					stickyAddToCartText.textContent = KROWN.settings.locales.products_sold_out_variant;
					if (stickyQuantitySelector) stickyQuantitySelector.style.display = 'none';
				} else {
					stickyAddToCartButton.classList.remove('disabled');
					stickyAddToCartText.textContent = KROWN.settings.locales.products_add_to_cart_button;
					if (stickyQuantitySelector) stickyQuantitySelector.style.display = '';
				}
			}
		}

	}

	if ( typeof customElements.get('sticky-bar') == 'undefined' ) {
		customElements.define('sticky-bar', StickyBar);
	}

}
